module.exports = ".maxWidth {\n  max-width: 800px; \n  margin: 0 auto;\n  margin-top: 5px;\n  margin-bottom: 20px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/dynamic-form/dynamic-form.component.css
// module id = ./src/app/dynamic-form/dynamic-form.component.css
// module chunks = main